module.exports = __webpack_public_path__ + "static/media/Brown_white.d43b55fd.png";